import React from 'react';

const Gallery = () => {
  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/cshpbvv8_vlcsnap-2022-01-01-16h11m22s204-2.png',
      title: 'Modern Dairy Plant',
      description: 'State-of-the-art production facility'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/7vjd53id_2022-01-02%20%281%29.png',
      title: 'Quality Products',
      description: 'Premium dairy products range'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/m6o1q6t0_our%20certifications.png',
      title: 'Certifications',
      description: 'ISO certified quality standards'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-rose-500 to-red-500 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">Our Gallery</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Explore our world-class dairy facility and product range
          </p>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div className="aspect-w-16 aspect-h-12 bg-gray-200">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-64 object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{image.title}</h3>
                <p className="text-gray-600">{image.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Video Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Factory Tour Video</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl mx-auto">
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                src="https://www.youtube.com/embed/aFWFqtGOnHA"
                title="Arihant Dairy Plant Tour"
                className="w-full h-96 rounded-lg"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
